<template>
    <div class="animated fadeIn">
        <b-card>
            <form @submit.prevent="validate">
                <div class="form-row justify-content-start"  v-if="$auth.isPartner || $auth.isFinance">
                    <div class="col-md-2">
                        <div class="form-group">
                            <label>Tipo de visualização</label>
                            <select :class="{'custom-select': true}" v-model="viewType">
                                <option value="Partner">{{$auth.customerName}}</option>
                                <option value="Seller">Empresa</option>
                                <option value="Salesperson">Representante</option>
                            </select>
                        </div>
                    </div>                 
                    <div class="col-md-4" v-if="viewType != 'Partner'">
                        <div class="form-group">
                            <label>{{viewType == 'Seller' ? 'Empresas' : 'Representantes'}}</label>
                            <model-list-select
                                :list="customers.data"
                                option-value="id"
                                option-text="name"
                                v-model="request.customer"
                                :placeholder="viewType == 'Seller' ? 'Digite o nome da empresa' : 'Digite o nome do representante'"
                                @searchchange="searchCustomers"
                            ></model-list-select>
                        </div>
                    </div>                         
                </div>
                <div class="row justify-content-start">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Início</label>
                            <datepicker
                                :language="languages.ptBR"
                                :bootstrapStyling="true"
                                placeholder="Início"
                                :calendar-button="true"
                                calendar-button-icon="fa fa-calendar"
                                v-model="request.startDate"
                            ></datepicker>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                            <label>Término</label>
                            <datepicker
                                :language="languages.ptBR"
                                :bootstrapStyling="true"
                                placeholder="Termino"
                                :calendar-button="true"
                                calendar-button-icon="fa fa-calendar"
                                v-model="request.endDate"
                            ></datepicker>
                        </div>
                    </div>                    
                </div>
                <input type="submit" class="btn btn-primary" value="Buscar" />
            </form>
        </b-card>
        <template v-if="selectedCustomer.id != ''">
            <h4 class="mt-5 mb-3">{{selectedCustomer.name}}</h4>
            <balance-summary ref="bSummary" v-model="summaryModel" />
            <h4 class="mt-5 mb-3">Extrato</h4>
            <b-card>
                <c-table
                    @onPageIndexChanged="onPageIndexChanged"
                    :table-data="statementsResult"
                    :loading="loading"
                    :fields="statementsColumns"
                    :striped="true"
                    :export-enabled="false"               
                ></c-table>
            </b-card>
        </template>
        
    </div>
</template>
<script>
import entriesService from "../../services/Transactions/entriesService";
import sellerService from "../../services/Customer/sellerService";
import salesPersonService from "../../services/Customer/salesPersonService";
import transactionService from "../../services/Transactions/transactionService";
import moneyOutService from "../../services/MoneyFlow/moneyOutService";
import cTable from "../../components/base/Table.vue";
import { ModelListSelect } from "vue-search-select";
import Datepicker from "vuejs-datepicker";
import { getDateDayBefore } from "../../shared/utils";
import * as lang from "vuejs-datepicker/src/locale";
import BalanceSummary from "../../components/balance/summary2.vue";
import eventbus from '../../eventBus';
import listPage from '../../mixins/listPage';
export default {
    mixins: [listPage],
    components: {
        ModelListSelect,
        Datepicker,
        cTable,
        BalanceSummary
    },
    data() {
        return {
            viewType: 'Partner',    
            request: {               
                startDate: getDateDayBefore(new Date(), 1),
                endDate: new Date(),
                customer: {
                    id: this.$auth.customerId,
                    name: this.$auth.customerName
                }
            },
            customers: {
                data: [],
                query: '',
            },            
            languages: lang,
            selectedCustomer: {
                id: '',
                name: ''
            },
            statementsColumns: [
                { key: "transactionId", label: "Codigo", sortable: false },
                { key: "insertedAt", label: "Data", sortable: false },
                { key: "entryType", label: "Tipo", sortable: false },                                
                { key: "amount", label: "Valor", sortable: false },
                { key: "balance", label: "Saldo", sortable: false }
            ],
            statementsResult: this.getEmptyResult(),
            summaryModel: this.getEmptyBalanceSummary()
        }
    },
    watch:{
        'viewType': function(newValue, oldValue) { 
            this.customers.data = [];
            this.customers.query = '';
            this.selectedCustomer.id = '';
            this.selectedCustomer.name = '';
            this.request.customer.id = '';
            this.request.customer.name = '';
            if(oldValue != 'Partner' && newValue == 'Partner') {
                this.request.customer.id = this.$auth.customerId;
                this.request.customer.name = this.$auth.customerName;                
            }         
            if(this.$auth.isSeller || this.$auth.isSalesPerson) {
                this.request.customer.id = this.$auth.customerId;
                this.request.customer.name = this.$auth.customerName;
            }
        }
    },
    created() {
        if(this.$auth.isSeller || this.$auth.isSalesPerson) {
            this.viewType = this.$auth.businessType;
            
        }
    },
    methods: {
        validate() {
            if(this.request.customer.id == '') {
                return;
            }
            this.selectedCustomer.id = this.request.customer.id;
            this.selectedCustomer.name = this.request.customer.name;
            this.fetchSummaryData();
            this.fetchData(1);
        },
        fetchData(page) {
            if(this.request.customer.id == '') {
                return;
            }
            const self = this;
            this.showLoading();
            entriesService.statement(this.getRequestParams(), page)
                .then((response) => {
                        if(response.status == 204) {
                        self.statementsResult = self.getEmptyResult()
                        }
                        else {
                        self.statementsResult.data = response.data.data
                        let entry = {}
                        for(let i = 0; i <= self.statementsResult.data.length - 1; i++) {
                            entry = self.statementsResult.data[i];                            
                            switch(entry.type) {
                                case 'Withdraw':
                                    entry.entryType = 'Saque';
                                    entry.transactionId = entry.externalId;
                                    break;
                                case 'RentalFee':
                                    entry.entryType = 'Aluguel';
                                    entry.transactionId = entry.externalId;
                                    break;
                                case 'Chargeback':
                                    entry.entryType = 'Chargeback';
                                    entry.transactionId = entry.transactionId;
                                    break;
                                case 'TransactionInstallment':
                                    entry.entryType = 'Disponível transação';
                                    entry.transactionId = entry.transactionId;
                                    break;
                            }                
                        }
                        self.statementsResult.pageIndex = page
                        self.statementsResult.rowCount = response.data.total
                        self.statementsResult.pageSize = 10
                        }            
                        self.hideLoading();
                    },
                    () => {
                        self.result = self.getEmptyResult();
                        self.hideLoading();
                    }
                );
        },
        getRequestParams() {
            return {
                customerId: this.selectedCustomer.id,
                startDate: this.request.startDate,
                endDate: this.request.endDate,                
            }
        },
        getEmptyBalanceSummary() {
            return { available: 0, inProcess: 0, blocked: 0, total: 0, openDebits: 0 }
        },
        fetchSummaryData() {
            const self = this
            
            transactionService.balance({customerId: this.request.customer.id, customerType: this.viewType})
                .then(
                (response) => {
                        if (response.status == 204) {
                            self.summaryModel.available = 0;
                            self.summaryModel.inProcess = 0;
                            self.summaryModel.total = 0;
                            self.summaryModel.blocked = 0;
                            self.summaryModel.openDebits = 0;   
                        }
                        else {
                            self.summaryModel.available = response.data.available;
                            self.summaryModel.inProcess = response.data.inProcess;
                            self.summaryModel.total = response.data.total;              
                            self.summaryModel.blocked = response.data.onHold;
                            self.summaryModel.openDebits = response.data.openDebits;
                        }                        
                    },
                    () => {}
                );            
        },
        searchCustomers(newQuery) {
            if (newQuery == null || newQuery.length < 2) return;
            const self = this;
            
            if(this.viewType == 'Seller') {
                sellerService.all(newQuery).then(
                    (response) => {
                        self.customers.data = response.status == 204 ? [] : response.data;
                    },
                    () => {
                        self.customers.data = [];
                    }
                );
            }
            else {
                salesPersonService.all(newQuery, '').then(
                    (response) => {
                        self.customers.data = response.status == 204 ? [] : response.data;
                    },
                    () => {
                        self.customers.data = [];
                    }
                );
            }
            
        }              
    }
}
</script>